import {AddKeyResultFace,
  addStaffFace,
  addTeamFace,pSoFace,
  addMissionFace,
  addContractFace,
  addCompanyFace,
  resetPasswordFace,
  registerByCodeFace,
  registerTenantFace,
  addObjectiveFace,
  
  
} from '../Interfaces/Interfaces';
import * as yup from 'yup';


const addKrValues:AddKeyResultFace={
name:'',
horizontalAlignments:[],
keyResultType:'',
forceEndDate:null,
responsibleId:'',
pointingSystemType:'Regularly',
startDate:null,
startValue:'',
weight:null,
description:'',
nameType: "normal",
valuesDetailCommandDtos:[],
oKRStateId:''
}

// const addObjectiveValues:AddObjectiveFace={
//     objectiveDescription:'',
//     descriptions:'',
//     levelId:'',
//     periodId:'',
//     responsibleId:'',
//     teamID:'',
//     teamsOrPersonsId:'',
//     TheReasonImportant:'',
//     weight:''
// }




const addTeamValues:addTeamFace={
  title:'',
  manager:'',
  members:''
}
const addMissionValues:addMissionFace={
mission:'',
phoneNumber:''
}

const addContractValues:addContractFace={
  startDate:'',
  countOfSaledDay:0,
  countOfUser:0
}

const addCompanyValues:addCompanyFace={
  fName:'',
  lName:'',
  companyName:''
}

const resetFormValues:resetPasswordFace={
  currentPassword:'',
  newPassword:'',
  repeatPassword:''
}
const registerFormValues:registerByCodeFace={
  jobType:'',
  firstName:'',
  lastName:'',
  password:'',
  confirmPassword:'',
  email:''
}


const registerTenantFormValues:registerTenantFace={
  jobType:'',
  cEO:'',
  firstName:'',
  lastName:'',
  password:'',
  personCount:'',
  confirmPassword:'',
  email: ''

}




  const pointSystem:any[]=[
    {key:'  کششی  ' ,value:'Tensile',desc:'تعیین مقدار مورد انتظار در سه سطح 30% و 70% و 100 %'},
    {key:'  متداول  ' ,value:'Regularly',desc:'تعیین مقدار مورد انتظار تنهادر سطح 100%'}
  ]

  const kRType:any[]=[
    {key:'  آرمانی  ' ,value:'Ideal'},
    {key:'  تعهدی  ' ,value:'Obligation'}
  ]


  const keyResultTypeOptions:pSoFace[]=[
   {
    key:'عددی',
    value:'Numerical'
    }
   ,
   {
    key:'درصدی',
    value:'Percentage'
    },
    {
        key:'مرحله ای',
        value:'Phase'
    }

  ]


const addObjectiveSchema = yup.object().shape({
  name:yup.string().required(''),
  periodId:yup.string().required(''),
  responsibleId:yup.string().required(''),
  definitionLevelId:yup.string().required(''),
  weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
});


const editObjectiveSchema = yup.object().shape({
  name:yup.string().required(''),
  periodId:yup.string().required(''),
  responsibleId:yup.string().required(''),
  definitionLevelId:yup.string().required(''),
  weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
});

// name:string,
// responsibleId:string,
// pointingSystemType:string,
// keyResultType:string,
// startValue:string,

const addKeyResultSchema=yup.object().shape({
  // name:yup.string().required('شرح نتیجه کلیدی اجباری است'),
  responsibleId:yup.string().required('انتخاب مسئول اجباری است' ),
  pointingSystemType:yup.string().required('سیستم امتیاز دهی اجباری است'),
  keyResultType:yup.string().required('نوع نتیجه کلیدی الزامی است'),
  startValue:yup.string().required('مقدار شروع الزامی است'),
  // Regularly:yup.string().required('مقدار آرمانی الزامی است'),
  weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
})


const editKeyResultSchema=yup.object().shape({
  // name:yup.string(),
  responsibleId:yup.string().required(''),
  pointingSystemType:yup.string().required(''),
  keyResultType:yup.string().required(''),
  startValue:yup.string().required(''),
  weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
})



export   {
    addKrValues,
    // addObjectiveInitialValues,
    pointSystem,
    kRType,
    keyResultTypeOptions,
    registerTenantFormValues,
    addTeamValues,
    addMissionValues,
    addContractValues,
    addCompanyValues,
    resetFormValues,
    registerFormValues,
    addObjectiveSchema,
    editObjectiveSchema,
    editKeyResultSchema,
    addKeyResultSchema
    
    
}